import Vue from 'vue';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import TransactionClassifications from './components/TransactionClassifications.vue';
import Lists from './components/Lists.vue';
import CMS from './components/CMS.vue';
import Criteria from './components/Criteria.vue';
import PSMs from './components/PSMs.vue';
import AllPSMs from './components/AllPSMs.vue';
import Products from './components/Products.vue';
import FinancialPlans from './components/FinancialPlans.vue';
import Achievements from './components/Achievements.vue';
import Questions from './components/Questions.vue';
import QuestionsV2 from './components/QuestionsV2.vue';
import GuideAdmin from './components/GuideAdmin.vue';
import OfflinePolicySections from './components/OfflinePolicySections.vue';
import ReportGenerator from './components/ReportGenerator.vue';
import Vouchers from './components/Vouchers.vue';
import VoucherCategories from './components/VoucherCategories/VoucherCategories.vue';
import VoucherReport from './components/VoucherReport/VoucherReport.vue';
import Wellbeing from './components/Wellbeing.vue';
import Home from './components/Home.vue';
import Stats from './components/Stats.vue';
import Login from './components/Login.vue';
import Upload from './components/Upload.vue';
import CustomerAdmin from './components/CustomerAdmin.vue';
import LiveSessions from './components/LiveSessions.vue';
import Employers from './components/Employers.vue';
import Merchants from './components/Merchants.vue';
import CustomerUploads from './components/CustomerUploads.vue';
import AIChatSettings from './components/AIChatSettings.vue';
import AIChatMessages from './components/AIChatMessages.vue';
import LgtClientLinks from './components/LgtClientLinks.vue';
import UntaggedTransactions from './components/UntaggedTransactions.vue';
import WhiteListFactCard from './components/WhiteListFactCard.vue';
import Cache from './components/Cache.vue';
import Router from'vue-router';
import axios from'axios';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Router);
Vue.use(axios);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.prototype.$http = axios;

const router = new Router({
	routes:[
		{ path:'/classifications', name:'transactionClassifications', component:TransactionClassifications },
		{ path:'/lists', name:'lists', component:Lists },
		{ path:'/cms', name:'cms', component:CMS },
		{ path:'/psms', name:'psms', component:PSMs },
		{ path:'/allpsms', name:'allPsms', component:AllPSMs },
		{ path:'/products', name:'products', component:Products },
		{ path:'/financialplans', name:'financialplans', component:FinancialPlans },
		{ path:'/achievements', name:'achievements', component: Achievements },
		{ path:'/questions', name:'questions', component: Questions },
		{ path:'/questionsv2', name:'questionsv2', component: QuestionsV2 },
		{ path:'/guideadmin', name:'guideadmin', component: GuideAdmin },
		{ path:'/offlinePolicySections', name:'offlinePolicySections', component: OfflinePolicySections },
		{ path:'/reportGenerator', name:'reportGenerator', component: ReportGenerator },
		{ path:'/vouchers', name:'vouchers', component: Vouchers },
		{ path:'/vouchercategories', name:'vouchercategories', component: VoucherCategories },
		{ path:'/voucherreport', name:'voucherreport', component: VoucherReport },
		{ path:'/wellbeing', name:'wellbeing', component: Wellbeing },
		{ path:'/home', name:'home', component:Home },
		{ path:'/stats', name:'stats', component:Stats },
		{ path:'/customers', name:'customers', component:CustomerAdmin },
		{ path:'/customeruploads', name:'customeruploads', component:CustomerUploads },
		{ path:'/livesessions', name:'sessions', component:LiveSessions },
		{ path:'/employers', name:'employers', component:Employers },
		{ path:'/lgtclientlinks', name:'lgtclientlinks', component:LgtClientLinks },
		{ path:'/merchants', name:'merchants', component:Merchants },
		{ path:'/aichatsettings', name:'aichatsettings', component:AIChatSettings },
		{ path:'/aichatmessages', name:'aichatmessages', component:AIChatMessages },
		{ path:'/cdn', name:'cdn', component:Upload },
		{ path:'/criteria', name:'criteria', component:Criteria },
		{ path:'/whitelistfactcard', name:'whitelistfactcard', component:WhiteListFactCard },
		{ path:'/untagged', name:'untagged', component:UntaggedTransactions },
		{ path:'/cache', name:'cache', component:Cache },
		{ path:'/', name:'login', component:Login }
	]
});

fetch(process.env.BASE_URL + "config.json")
  .then((response) => response.json())
  .then((config) => {
       Vue.prototype.$config = config
       new Vue({
         router,
         render: (h) => h(App)
       }).$mount("#app")
  })

